import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  matchPath,
  Outlet,
} from "react-router-dom";

// Main website components
import Navbar from "./Components/Navbar/Navbar";
import HomeComponent from "./Components/HomeComponent/HomeComponent";
import AboutVaranous from "./Components/AboutVaranous/AboutVaranous";
import Careers from "./Components/AboutVaranous/Careers";
import Investors from "./Components/AboutVaranous/Investors";
import VaranousLife from "./Components/AboutVaranous/VaranousLife";
import Products from "./Components/Products/Products";
import GetQuote from "./Components/GetQuote/GetQuote";
import ServicesDropdown from "./Components/Services/ServiceDropDown/ServiceDropDown";
import ServiceRoutes from "./Components/Services/Routing/ServiceRoutes";
import ScrollToTopButton from "./Components/ScrollTopButton/ScrollToTopButton";
import Catalogue from "./Components/Support/Catalogues/Catalogues";
import Contact from "./Components/Support/Contact/Contact";
import FAQS from "./Components/Support/FAQS/FAQS";
import ChatWidget from "./Components/HomeComponent/ChatWidget/ChatWidget";
import WhatsAppButton from "./Components/HomeComponent/WhatsAppButton/WhatsAppButton";
// import  Blogs from './Components/AboutVaranous/Blogs'
// Auth
// import Register from "./Components/Register/Register";
import Login from "./Components/Login/Login";
import Forgotpassword from "./Components/Forgotpassword/Forgotpassword";
import Resetpassword from "./Components/Resetpassword/Resetpassword";

// Terms and policies
import TermsAndConditions from "./Components/TermsOfUse/TermsAndConditions";
import RefundPolicy from "./Components/TermsOfUse/RefundPolicy";
import CancelationPolicy from "./Components/TermsOfUse/CancelationPolicy";
import ShippingPolicy from "./Components/TermsOfUse/ShippingPolicy";

// Other
import Facility from "./Components/Facility/Facility";
import Help from "./Components/Help/Help";
import ProductDetailPage from "./Components/Products/ProductDetailPage";

// Dashboard layout and content
import Dashboard from "./Components/MyDashboard/MyDashboard";
import HomeContent from "./Components/MyDashboard/Home_content";
import Rfqcontent from "./Components/MyDashboard/Rfq_content";
import QuotationsContent from "./Components/MyDashboard/quotation_content";
import Orders from "./Components/MyDashboard/Orders";
import ForgotResetPassword from "./Components/Login/ForgotResetPassword";
// import OrderDetails from "./Components/MyDashboard/ViewOrderDetails";

const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  const isDashboard = matchPath("/customerPortal/*", location.pathname);

  return (
    <>
      {!isDashboard && <Navbar />}
      {!isDashboard && <ServiceRoutes />}
      {!isDashboard && <ScrollToTopButton />}
      {!isDashboard && <ChatWidget />}
      {!isDashboard && <WhatsAppButton />}
      {children}
    </>
  );
};

function App() {
  return (
    <Router>
      <LayoutWrapper>
        <Routes>
          {/* Public Pages */}
          <Route path="/" element={<HomeComponent />} />
          <Route path="/about-varanous" element={<AboutVaranous />} />
          {/* <Route path="/blogs" element={<Blogs />} /> */}
          <Route path="/varanous-life" element={<VaranousLife />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/Products" element={<Products />} />
          {/* <Route path="/products/:slug" element={<Products />} /> */}
          <Route path="/get-quote" element={<GetQuote />} />
          <Route path="/ServicesDropdown" element={<ServicesDropdown />} />
          <Route path="/Catalogue" element={<Catalogue />} />
          <Route path="/faqs" element={<FAQS />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/product-detail/:catalogNumber"
            element={<ProductDetailPage />}
          />
          <Route path="/forgot-password" element={<ForgotResetPassword />} />

          {/* <Route path="/products/:slug" element={<Products />}>
            <Route path="product-detail/:catalogNumber" element={<ProductDetailPage />} />
          </Route> */}
          {/* path="/products/:letter/:category/product-detail/:catalogNumber"
          element={<ProductDetailPage />} */}
          {/* <Route path="/business-offerings" element={<BusinessOfferings />} /> */}
          {/* Auth Pages */}
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<Forgotpassword />} />
          <Route path="/reset-password" element={<Resetpassword />} />

          {/* Terms and Policies */}
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/cancellation-policy" element={<CancelationPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/facility" element={<Facility />} />
          <Route path="/help" element={<Help />} />

          {/* 🧩 Nested Dashboard Routes */}
          <Route path="/customerPortal" element={<Dashboard />}>
            <Route path="mydashboard" element={<HomeContent />} />
            <Route path="rfqs" element={<Rfqcontent />} />
            <Route path="quotations" element={<QuotationsContent />} />
            <Route path="orders" element={<Orders />} />
            {/* <Route path="/customerPortal/orders/details/:salesOrderNo" element={<OrderDetails />} /> */}
            {/* Add other nested dashboard routes here */}
          </Route>

          {/* Wildcard Route for Invalid URLs */}
          {/* <Route
            path="*"
            element={
              <div className="text-center text-red-500 p-6">Page Not Found 404 error</div>
            }
          /> */}
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

export default App;
